import {reportToBugsnag} from '../../../srcCommon/services/bugsnag/bugsnag';
import {offlineDraftMessages} from '../../../srcCommon/services/offline/offlineDraftMessages';
import {ApiMessageDataGroup} from '../../models/api/dataGroupModel';
import {DraftMessageModel, MessageVisualStatusesEnum} from '../../models/api/messageModel';
import {ThunkAsyncAction} from '../../store/appThunk';
import {fetchApiAsync} from '../http/http';
import {findMessageQueue} from './specializedTaskQueues';

export function reloadMessageTask(messageUid: string): ThunkAsyncAction<DraftMessageModel | undefined> {
  return async (dispatch, getState) => {
    // Wait for our turn to work.
    const queue = findMessageQueue(dispatch, getState, messageUid);
    await queue.waitForTurnAsync();

    try {
      // Only refresh messages that already exist in the state.
      const message = queue.getResult();
      if (!message) {
        queue.provideResultAsync({});
        return undefined;
      }

      // Fetch the full message.
      const serverDataGroup = await fetchApiAsync(ApiMessageDataGroup, message.url);

      // We must use the conversation queue if this data group contains conversations.
      if (serverDataGroup.conversations && serverDataGroup.conversations.length) {
        reportToBugsnag(new Error('Unexpected conversation in fetch for reloadMessageTask'));
      }

      // Discard the backup since we are reverting to the server version.
      await offlineDraftMessages.removeAsync(message);

      // Notify the queue and return the result.
      const result = await queue.provideResultAsync(serverDataGroup);
      if (!result || result.visualStatus !== MessageVisualStatusesEnum.DRAFT) {
        return undefined;
      }

      return result;
    } catch (error) {
      queue.reportError();
      throw error;
    }
  };
}
